import { getFeatures_features } from "./graphql/types/getFeatures";

export const isServer = () => typeof window === "undefined";
export const isClient = () => typeof window !== "undefined";

export const PASSWORD_LENGTH = 6;
export const LOCAL_COLLECT_RADIUS = "10";
export const LLOYDS_PHARMACY_SEARCH_RADIUS = 16090; // in metres, approx. 10 miles
export const REFILL_REMINDER_DAYS = 10;

export const COPY_ERROR_VALIDATION_PASSWORD_LENGTH =
  "Please enter a password that's at least " +
  PASSWORD_LENGTH +
  " characters long.";

export const validatePassword = (password: string) => {
  if (password.length < PASSWORD_LENGTH) {
    return COPY_ERROR_VALIDATION_PASSWORD_LENGTH;
  }
  return "";
};

export const canUseLocalCollect = (featureflags: getFeatures_features[]) => {
  const featureEnabled = featureflags.find(
    flag => flag.name === "local_collect" && flag.isEnabled
  );

  if (!featureEnabled) {
    return false;
  }

  return true;
};

export const getFullName = ({
  firstName,
  lastName
}: {
  firstName: string;
  lastName: string;
}) => {
  return `${firstName} ${lastName}`;
};
